// import { Component, OnInit } from '@angular/core';
// import { ToastrService } from 'ngx-toastr';
// import { DataService } from "src/app/shared/Services/data.service";

// @Component({
//   selector: 'app-operator-mapping',
//   templateUrl: './operator-mapping.component.html',
//   styleUrls: ['./operator-mapping.component.scss']
// })
// export class OperatorMappingComponent implements OnInit {

//   usersData: any[] = [];
//   operator: any[] = [];

//   breadCrumbItems: any[] = [];
//   userData: any;
//   custId: any;

//   departments: any[] = [];
//   selecteddepartmentName = '';
//   selectedDepartment: any = null;

//   deviceData: any[] = [];
//   devicelistData: any[] = [];

//   selectedOperators: any = {};

//   constructor(
//     private toastr: ToastrService,
//     private dataservice: DataService
//   ) {}

//   ngOnInit(): void {
//     this.userData = JSON.parse(sessionStorage.getItem("currentUser") || '{}');
//     this.custId = this.userData?.user?.custId;

//     this.breadCrumbItems = [
//       { label: "Configuration" },
//       { label: "Operator Mapping", active: true },
//     ];

//     // Load users first, then departments
//     this.getUser();
//   }

//   // ==========================
//   // GET DEPARTMENTS
//   // ==========================
//   getDepartment() {
//     this.dataservice.get("department").subscribe({
//       next: (res: any) => {
//         if (res?.data) {
//           this.departments = res.data;

//           if (this.departments.length) {
//             this.selectedDepartment = this.departments[0];
//             this.selecteddepartmentName = this.selectedDepartment.departmentName;

//             this.getDevice();
//           }
//         }
//       },
//       error: (err) => this.toastr.error(err.message)
//     });
//   }

//   departmentChange(deptName: string) {
//     this.selecteddepartmentName = deptName;

//     this.selectedDepartment = this.departments.find(
//       d => d.departmentName === deptName
//     );

//     this.devicelistData = [];
//     this.selectedOperators = {};

//     this.getDevice();
//   }

//   // ==========================
//   // GET DEVICES
//   // ==========================
//   getDevice() {
//     this.dataservice.get("api/device").subscribe({
//       next: (res: any) => {
//         this.deviceData = res || [];

//         this.devicelistData = this.deviceData.filter(
//           d => d.departmentName === this.selecteddepartmentName
//         );

//         this.initializeMapping();
//       },
//       error: () => this.toastr.error("Server Error")
//     });
//   }

//   // ==========================
//   // INITIALIZE MAPPING
//   // ==========================
//   initializeMapping() {
//     this.selectedOperators = {};

//     if (!this.selectedDepartment?.shiftData?.length) return;

//     this.devicelistData.forEach((device: any) => {
//       this.selectedOperators[device.deviceId] = {};

//       // Initialize all shifts first with "Not Mapped"
//       this.selectedDepartment.shiftData.forEach((shift: any) => {
//         this.selectedOperators[device.deviceId][shift.shiftName] = null; // Use operatorId instead of object
//       });

//       // Override with existing mappings
//       if (device.mappedData?.length) {
//         device.mappedData.forEach((map: any) => {
//           this.selectedOperators[device.deviceId][map.shiftName] = map.operatorId;
//         });
//       }
//     });
//   }

//   // ==========================
//   // GET USERS / OPERATORS
//   // ==========================
//   getUser() {
//     this.dataservice.get("api/user").subscribe({
//       next: (res: any) => {
//         this.usersData = res || [];

//         this.operator = [
//           { id: null, name: "Not Mapped", email: "Not Mapped" },
//           ...this.usersData
//             .filter((u: any) => u.role === "OPERATOR")
//             .map((u: any) => ({
//               id: u.id,
//               name: u.name,
//               email: u.email
//             }))
//         ];

//         // Load departments after operators are loaded
//         this.getDepartment();
//       },
//       error: (err) => this.toastr.error(err.message)
//     });
//   }

//   // ==========================
//   // ON CHANGE (MAIN LOGIC)
//   // ==========================
//   onOperatorChange(device: any, shift: any) {
//     const shiftName = shift.shiftName;
//     const shiftId = shift.usershiftId;

//     const selectedOperatorId = this.selectedOperators[device.deviceId][shiftName];
    
//     // Find the full operator object
//     const selectedOperator = this.operator.find(op => op.id === selectedOperatorId);

//     if (!device.mappedData) {
//       device.mappedData = [];
//     }

//     const existing = device.mappedData.find(
//       (m: any) => m.shiftId === shiftId
//     );

//     const mappedObj = {
//       shiftId: shiftId,
//       shiftName: shiftName,
//       operatorId: selectedOperator?.id,
//       operatorName: selectedOperator?.name,
//       operatorEmail: selectedOperator?.email
//     };

//     if (existing) {
//       Object.assign(existing, mappedObj);
//     } else {
//       device.mappedData.push(mappedObj);
//     }

//     const payload = {
//       custId: this.custId,
//       deviceId: device.deviceId,
//       mappedData: device.mappedData
//     };

//     this.dataservice
//       .put(`mapping/operator/${device['id']}`, payload)
//       .subscribe({
//         next: () => {
//           this.toastr.success("Operator Mapped Successfully");
//           // Don't call getDevice() - just update the local state
//         },
//         error: (err) => this.toastr.error(err.message)
//       });
//   }
// }


import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DataService } from "src/app/shared/Services/data.service";

@Component({
  selector: 'app-operator-mapping',
  templateUrl: './operator-mapping.component.html',
  styleUrls: ['./operator-mapping.component.scss']
})
export class OperatorMappingComponent implements OnInit {

  usersData: any[] = [];
  operator: any[] = [];

  breadCrumbItems: any[] = [];
  userData: any;
  custId: any;

  departments: any[] = [];
  selecteddepartmentName = '';
  selectedDepartment: any = null;

  deviceData: any[] = [];
  devicelistData: any[] = [];

  // Now stores array of operator IDs per device
  selectedOperators: any = {};

  // Track dropdown open state per device
  dropdownOpen: { [deviceId: string]: boolean } = {};

  constructor(
    private toastr: ToastrService,
    private dataservice: DataService
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(sessionStorage.getItem("currentUser") || '{}');
    this.custId = this.userData?.user?.custId;

    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Operator Mapping", active: true },
    ];

    this.getUser();
  }

  // ==========================
  // GET DEPARTMENTS
  // ==========================
  getDepartment() {
    this.dataservice.get("department").subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.departments = res.data;
          if (this.departments.length) {
            this.selectedDepartment = this.departments[0];
            this.selecteddepartmentName = this.selectedDepartment.departmentName;
            this.getDevice();
          }
        }
      },
      error: (err) => this.toastr.error(err.message)
    });
  }

  departmentChange(deptName: string) {
    this.selecteddepartmentName = deptName;
    this.selectedDepartment = this.departments.find(d => d.departmentName === deptName);
    this.devicelistData = [];
    this.selectedOperators = {};
    this.dropdownOpen = {};
    this.getDevice();
  }

  // ==========================
  // GET DEVICES
  // ==========================
  getDevice() {
    this.dataservice.get("api/device").subscribe({
      next: (res: any) => {
        this.deviceData = res || [];
        this.devicelistData = this.deviceData.filter(
          d => d.departmentName === this.selecteddepartmentName
        );
        this.initializeMapping();
      },
      error: () => this.toastr.error("Server Error")
    });
  }

  // ==========================
  // INITIALIZE MAPPING
  // ==========================
  initializeMapping() {
    this.selectedOperators = {};
    this.dropdownOpen = {};

    this.devicelistData.forEach((device: any) => {
      // Pre-populate from existing mappedData (array of operatorIds)
      if (device.mappedData?.length) {
        this.selectedOperators[device.deviceId] = device.mappedData.map((m: any) => m.id);
      } else {
        this.selectedOperators[device.deviceId] = [];
      }
      this.dropdownOpen[device.deviceId] = false;
    });
  }

  // ==========================
  // GET USERS / OPERATORS
  // ==========================
  getUser() {
    this.dataservice.get("api/user").subscribe({
      next: (res: any) => {
        this.usersData = res || [];
        this.operator = this.usersData
          .filter((u: any) => u.role === "OPERATOR")
          .map((u: any) => ({ id: u.id, name: u.name, email: u.email }));

        this.getDepartment();
      },
      error: (err) => this.toastr.error(err.message)
    });
  }

  // ==========================
  // MULTI-SELECT HELPERS
  // ==========================
  toggleDropdown(deviceId: string) {
    // Close all others first
    Object.keys(this.dropdownOpen).forEach(id => {
      if (id !== deviceId) this.dropdownOpen[id] = false;
    });
    this.dropdownOpen[deviceId] = !this.dropdownOpen[deviceId];
  }

  isSelected(deviceId: string, operatorId: any): boolean {
    return (this.selectedOperators[deviceId] || []).includes(operatorId);
  }

  toggleOperator(device: any, operatorId: any) {
    const list: any[] = this.selectedOperators[device.deviceId] || [];
    const idx = list.indexOf(operatorId);
    if (idx === -1) {
      list.push(operatorId);
    } else {
      list.splice(idx, 1);
    }
    this.selectedOperators[device.deviceId] = [...list];
    this.saveMapping(device);
  }

getSelectedNames(deviceId: string): string {
  const ids: any[] = this.selectedOperators[deviceId] || [];
  if (!ids.length) return 'Not Mapped';  // ← changed from 'Select Operators'
  return ids
    .map(id => this.operator.find(op => op.id === id)?.name || '')
    .filter(Boolean)
    .join(', ');
}

  // ==========================
  // SAVE MAPPING
  // ==========================
  saveMapping(device: any) {
    const selectedIds: any[] = this.selectedOperators[device.deviceId] || [];

    const mappedData = selectedIds.map(id => {
      const op = this.operator.find(o => o.id === id);
      return op?.id
    });

    const payload = {
      custId: this.custId,
      deviceId: device.deviceId,
      mappedData
    };

    this.dataservice.put(`mapping/operator/${device['id']}`, payload).subscribe({
      next: () => {this.toastr.success("Operator Mapped Successfully"),this.getDevice()},
      error: (err) => this.toastr.error(err.message)
    });
  }

  // Close dropdowns when clicking outside
  closeAllDropdowns() {
    Object.keys(this.dropdownOpen).forEach(id => this.dropdownOpen[id] = false);
  }
}